<div *ngIf="errors" class="alert alert-danger alert-dismissible fade show">
  Make sure to enter the Print name and to accept all the checkboxes.
  <button (click)="errors = false" aria-label="Close" class="close" type="button">
    <div aria-hidden="true">&times;</div>
  </button>
</div>
<div *ngIf="successDeclaration" class="alert alert-success alert-dismissible fade show">
  The declaration has been successfully submitted.
  <button (click)="successDeclaration = false" aria-label="Close" class="close" type="button">
    <div aria-hidden="true">&times;</div>
  </button>
</div>
<div *ngIf="serverError" class="alert alert-danger alert-dismissible fade show">
  An error has occurred while submitting your declaration.
  <button (click)="errors = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="expiredError" class="alert alert-danger alert-dismissible fade show">
  This dad form is no longer editable.
  <button (click)="errors = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div [formGroup]="dadDeclarationForm" class="container">
  <h4 style="margin-bottom: 0; line-height: 100%; text-align: center ">
    <b>
      <u>Schedule {{ scheduleNumber }}</u>
      <br/>
      <u>Monthly Data Access Declaration ({{ currentDad.dadConfig.exchangeNameInTitle }})</u>
    </b>
  </h4>
  <br>
  <div>
    <b>Vendor Providing the Datafeed:</b> {{ currentDad.vendor }}
  </div>
  <div>
    <b>Subscriber Name: </b>{{ currentDad.billingAccount?.name }}
  </div>
  <br>
  <div>
    <b>Location Address covered on this report: </b>
  </div>
  <ng-content select="span"></ng-content>
  <br>
  <table>
    <tr *ngFor="let pop of currentDad.decodedPopList">
      <td style="text-align:center; font-weight:bold;"> &#8226;</td>
      <td style="padding: 3px">{{ pop.name }}</td>
      <td style="padding: 3px">{{ pop.street }}</td>
      <td style="padding: 3px">{{ pop.city }}</td>
      <td style="padding: 3px">{{ pop.state }}</td>
      <td style="padding: 3px">{{ pop.postal_code }}</td>
    </tr>
  </table>
  <br>
  <div>
    <b id="bold-title">This Declaration Form covers data in relation to the following Exchange for the month(s)
      listed</b>
  </div>
  <br/>
  <div style="display: inline-block;">
    <table class="declaration-table">
      <thead>
      <tr>
        <th>Quincy Data exchange name</th>
        <th>{{ currentDad.dadConfig.exchangeNameInTitle | uppercase }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="seePreviousMonthDeclaration" class="tr-previous-month-declaration">
        <th># of Access IDs for {{ previousUsageMonth | date: 'MMMM y':'+8000' }}</th>
        <td><input [disabled]="true" [value]="previousMonthDeclaration" type="number"></td>
      </tr>
      <tr *ngIf="seeOriginalClientDeclaration" class="tr-previous-month-declaration">
        <th>Original client count {{ currentDad.usageMonth | date: 'MMMM y':'+8000' }}</th>
        <td><input [disabled]="true" [value]="originalClientDeclaration" type="number"></td>
      </tr>
      <tr *ngIf="!originalClientDeclarationMode">
        <td># of Access IDs for {{ currentDad.usageMonth | date: 'MMMM y':'+8000' }}</td>
        <td><input formControlName="accessIds" min="0" type="number"></td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="row" style="margin-left: 0;" *ngIf="!originalClientDeclarationMode">
    <button (click)="toggleSeePreviousMonthDeclaration()" *ngIf="previousMonthSubscriptionData?.declarations" class="p-button-alert"
            label="{{previousMonthDeclarationBtnLabel}}" pButton></button>
    <button (click)="toggleSeeOriginalClientDeclaration()" *ngIf="currentDad.decodedOriginalClientDeclaration" class="p-button-info" style="margin-left: 5px;"
            label="{{originalClientDeclarationBtnLabel}}" pButton></button>
  </div>
  <br/>
  <ng-content select="div"></ng-content>
  <br>
  <app-confirmation-section [currentDad]="currentDad" [formGroup]="dadDeclarationForm" [originalClientDeclarationMode]="originalClientDeclarationMode"
                            [previousMonthSubscriptionData]="previousMonthSubscriptionData"
                            [scheduleNumber]="scheduleNumber"></app-confirmation-section>
  <br>
  <div class="form-group pl-2" *ngIf="!originalClientDeclarationMode">
    <button (click)="onSubmit()" class="p-button-success pull-right" icon="fa fa-floppy-o" label="Confirm and transmit your declaration"
            pButton type="submit"></button>
    <button class="p-button-danger pull-right" label="Cancel" pButton routerLink="/dad-admin"
            style="margin-right: 5px"></button>
  </div>
</div>
